import React from 'react';
import {
  DefaultButton,
  PrimaryButton,
  Spinner,
  SpinnerSize,
  TextField,
} from 'office-ui-fabric-react';
import { useTranslation } from 'react-i18next';

const CommentResponse = ({
  showCommentReply,
  textValue,
  onChangeText,
  isEditMode,
  cancelCreateReply,
  confirmCreateReply,
  showSpinner,
}) => {
  const { t: translator } = useTranslation();
  if (!showCommentReply) {
    return null;
  }

  return (
    <div className="hearing-response-box--is-reply">
      {isEditMode ? (
        <div>
          <TextField
            value={textValue}
            onChange={(_, value) => onChangeText(value)}
            multiline
            styles={textFieldStyles}
          />
          <div className="panel-buttons--no-padding">
            {showSpinner && <Spinner size={SpinnerSize.large} />}
            <DefaultButton
              text={translator('global.cancel')}
              onClick={cancelCreateReply}
              disabled={showSpinner}
            />
            <PrimaryButton
              text={translator('global.confirm')}
              disabled={showSpinner}
              onClick={confirmCreateReply}
            />
          </div>
        </div>
      ) : (
        textValue
      )}
    </div>
  );
};

const textFieldStyles = {
  root: {
    marginBottom: '20px',
  },
  field: {
    minHeight: '100px',
    maxHeight: '300px',
  },
};

export { CommentResponse };
